/**
 * 생활기록부 맞춤법 검사 한시 공개 기간 (#316, 사용자 결정 2026-11-02).
 * 기간을 바꿀 곳은 이 파일 두 상수뿐이다.
 * 끝 시각은 2027-02-28 하루가 다 지난 시점(3월 1일 0시, 한국 시간)이다.
 */
export const SAENGGIBU_OPEN_AT = '2026-11-03T00:00:00+09:00';
export const SAENGGIBU_CLOSE_AT = '2027-03-01T00:00:00+09:00';

/** 화면에 보이는 기간 문구. 위 상수와 같이 고친다. */
export const SAENGGIBU_PERIOD_LABEL = '2026년 11월 3일부터 2027년 2월 28일까지';

/**
 * 공개 중지 스위치 (사용자 지시 2026-11-05).
 * true 면 기간과 상관없이 메뉴·배너에서 숨기고 /saenggibu 는 '준비 중' 안내만 보인다.
 * 다시 열 때는 이 값을 false 로 바꾸면 된다.
 */
export const SAENGGIBU_SUSPENDED = false;

/**
 * 숨김 공개 스위치 (사용자 지시 2026-11-05, #316 note_343117).
 * true 면 /saenggibu 는 주소로만 열리고 메뉴·배너·검색 색인에는 나오지 않는다.
 * 몇 명에게 피드백을 받은 뒤 공식 오픈하기로 하면 이 값을 false 로 바꾼다.
 * (SAENGGIBU_SUSPENDED 는 서비스를 아예 내리는 스위치라 true 가 우선한다.)
 */
export const SAENGGIBU_HIDDEN = true;

/**
 * before/closed/suspended: 화면에 안내만 보인다.
 * hidden: 기간 안이고 검사는 되지만 어디에도 걸지 않는다 (숨김 공개).
 * open: 기간 안이고 메뉴·배너에도 건다 (공식 오픈).
 */
export type SaenggibuPeriodState =
  | 'before'
  | 'open'
  | 'hidden'
  | 'closed'
  | 'suspended';

export function getSaenggibuPeriodState(
  now: Date = new Date(),
  suspended: boolean = SAENGGIBU_SUSPENDED,
  hidden: boolean = SAENGGIBU_HIDDEN
): SaenggibuPeriodState {
  if (suspended) return 'suspended';
  const t = now.getTime();
  if (t < Date.parse(SAENGGIBU_OPEN_AT)) return 'before';
  if (t >= Date.parse(SAENGGIBU_CLOSE_AT)) return 'closed';
  return hidden ? 'hidden' : 'open';
}

/** 검사를 쓸 수 있는 상태(공식 오픈 또는 숨김 공개). 메뉴·배너는 'open' 만 건다. */
export function isSaenggibuUsable(state: SaenggibuPeriodState): boolean {
  return state === 'open' || state === 'hidden';
}

/** 남은 일수(올림). 열려 있을 때만 의미가 있다. */
export function getSaenggibuDaysLeft(now: Date = new Date()): number {
  const ms = Date.parse(SAENGGIBU_CLOSE_AT) - now.getTime();
  return Math.max(0, Math.ceil(ms / 86_400_000));
}

/**
 * 메뉴·탭 줄에 생활기록부 항목을 넣을지 (사용자 지시 2026-11-05, #316 note_343200·note_343209).
 * 공식 오픈(open)은 모두에게 보인다. 숨김 공개(hidden)는 /saenggibu 주소로 들어온 방문자의
 * 그 세션에서만 보인다(seen). 나머지 상태에서는 보이지 않는다.
 * 정식 공개는 SAENGGIBU_HIDDEN=false 한 줄이다.
 */
export function isSaenggibuTabShown(
  state: SaenggibuPeriodState,
  seen: boolean = false
): boolean {
  return state === 'open' || (state === 'hidden' && seen);
}
